import React, {useState} from 'react';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Logo from "../../../../Assets/Images/logo.png";
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from "react-router-dom";
import MicNoneIcon from "@mui/icons-material/MicNone";
import LibraryMusicOutlinedIcon from "@mui/icons-material/LibraryMusicOutlined";
import PodcastsRoundedIcon from "@mui/icons-material/PodcastsRounded";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import QueueMusicOutlinedIcon from "@mui/icons-material/QueueMusicOutlined";

export default function Header(props) {
    const [drawerIsOpen, setDrawerIsOpen] = useState(false)
    const [isLogin, setIsLogin] = useState(true)
    const [valueSearch, setValueSearch] = React.useState('');
    const navigate = useNavigate();


    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <header
            className='flex flex-row justify-between items-center p-4 sticky top-0 w-full transiton-all duration-100 ease-out z-20 shadow-menu md:shadow-none backdrop-blur-2xl blur-0 opacity-100'
        >
            {/*<TextField
                className='!rounded-full'
                label="جستجو"
                focused
                value={valueSearch}
                onChange={(event) => {
                    setValueSearch(event.target.value);
                }}
            />*/}
            <input type="text"
                   className="hidden md:block bg-transparent border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-gray-400 focus:border-gray-400 focus-visible:outline-none block w-[300px] p-2"
                   placeholder="جستجو"
                   onFocus={() => navigate("search")}
                   required
            />

                <div className="flex flex-row justify-between md:hidden">
                    <div className='ml-1'>
                        <Button onClick={() => setDrawerIsOpen(!drawerIsOpen)}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                                 stroke="currentColor" className="w-8 h-8 text-gray-600">
                                <path strokeLinecap="round" strokeLinejoin="round"
                                      d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"/>
                            </svg>
                        </Button>
                        <Drawer
                            anchor={'left'}
                            open={drawerIsOpen}
                            onClose={() => setDrawerIsOpen(!drawerIsOpen)}
                        >
                            <div className="p-4">
                                <a href="#" className='flex justify-center'>
                                    <img src={Logo} alt='logo' className='w-[6rem]'/>
                                </a>
                                <div className="flex flex-col space-y-4 text-sm">
                                    <div className="flex flex-row items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                             strokeWidth={1.5}
                                             stroke="currentColor" className="w-5 h-5 ml-1">
                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                  d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"/>
                                        </svg>

                                        <div className='text-md font-normal'>خانه</div>
                                    </div>
                                    <div className="flex flex-row items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                             strokeWidth={1.5}
                                             stroke="currentColor" className="w-5 h-5 ml-1">
                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                  d="M6 6.878V6a2.25 2.25 0 012.25-2.25h7.5A2.25 2.25 0 0118 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 004.5 9v.878m13.5-3A2.25 2.25 0 0119.5 9v.878m0 0a2.246 2.246 0 00-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0121 12v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6c0-.98.626-1.813 1.5-2.122"/>
                                        </svg>
                                        <div className='text-md font-normal'>مرورگر</div>
                                    </div>
                                    <div className="flex flex-row items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                             strokeWidth={1.5}
                                             stroke="currentColor" className="w-5 h-5 ml-1">
                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/>
                                        </svg>

                                        <div className='text-md font-normal'>جستجو</div>
                                    </div>
                                    <Divider variant="middle"/>
                                    <div className="flex flex-row items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                             strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 ml-2">
                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                  d="M9 9l10.5-3m0 6.553v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 11-.99-3.467l2.31-.66a2.25 2.25 0 001.632-2.163zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 01-.99-3.467l2.31-.66A2.25 2.25 0 009 15.553z"/>
                                        </svg>
                                        <div className='text-md font-normal'>موسیقی</div>
                                    </div>
                                    <div className="flex flex-row items-center">
                                        <MicNoneIcon className='ml-2'/>
                                        <div className='text-md font-normal'>هنرمند</div>
                                    </div>
                                    <div className="flex flex-row items-center">
                                        <LibraryMusicOutlinedIcon className='ml-2'/>
                                        <div className='text-md font-normal'>آلبوم</div>
                                    </div>
                                    <div className="flex flex-row items-center">
                                        <PodcastsRoundedIcon className='ml-2'/>
                                        <div className='text-md font-normal'>پادکست</div>
                                    </div>
                                    <div className="flex flex-row items-center">
                                        <AutoStoriesOutlinedIcon className='ml-2'/>
                                        <div className='text-md font-normal'>کتاب صوتی</div>
                                    </div>
                                    <div className="flex flex-row items-center">
                                        <QueueMusicOutlinedIcon className='ml-2'/>
                                        <div className='text-md font-normal'>پلی لیست ها</div>
                                    </div>
                                </div>
                            </div>
                        </Drawer>
                    </div>
                    <img src={Logo} alt="logo" className='w-[50px] h-[50px] '/>
                </div>
                {
                    isLogin
                        ? <React.Fragment>
                            <Tooltip title="پروفایل">
                                <IconButton
                                    onClick={handleClick}
                                    size="small"
                                    sx={{ml: 2}}
                                    aria-controls={open ? 'account-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 ml-1">
                                        <path strokeLinecap="round" strokeLinejoin="round"
                                              d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         strokeWidth={1.5}
                                         stroke="currentColor" className="w-4 h-4">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
                                    </svg>
                                </IconButton>
                            </Tooltip>
                            <Menu
                                anchorEl={anchorEl}
                                id="account-menu"
                                open={open}
                                onClose={handleClose}
                                onClick={handleClose}
                                PaperProps={{
                                    elevation: 0,
                                    sx: {
                                        overflow: 'visible',
                                        boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);',
                                        borderRadius: '1rem',
                                        fontSize: '8px',
                                        padding: '1rem',
                                        mt: 1.5,
                                        '& .MuiAvatar-root': {
                                            width: 40,
                                            height: 40,
                                            ml: 1,
                                        },

                                    },
                                }}
                                transformOrigin={{horizontal: 'right', vertical: 'top'}}
                                anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                            >
                                <MenuItem onClick={handleClose} sx={{borderRadius: '1rem'}}>
                                    <div className="flex flex-row items-center">
                                        <Avatar/>
                                        <div className="flex flex-col mr-4 text-sm text-gray-500 space-y-2">
                                            <span className='font-medium'>میلاد زارع</span>
                                            <span>09335137958</span>
                                        </div>
                                    </div>
                                </MenuItem>
                                <Divider/>
                                <MenuItem onClick={handleClose} sx={{borderRadius: '1rem'}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         strokeWidth={1.5}
                                         stroke="currentColor" className="w-4 h-4 ml-2">
                                        <path strokeLinecap="round" strokeLinejoin="round"
                                              d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"/>
                                    </svg>
                                    <span className='text-sm'>حساب کاربری</span>
                                </MenuItem>
                                <MenuItem onClick={handleClose} sx={{borderRadius: '1rem'}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         strokeWidth={1.5}
                                         stroke="currentColor" className="w-4 h-4 ml-2">
                                        <path strokeLinecap="round" strokeLinejoin="round"
                                              d="M9 9l10.5-3m0 6.553v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 11-.99-3.467l2.31-.66a2.25 2.25 0 001.632-2.163zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 01-.99-3.467l2.31-.66A2.25 2.25 0 009 15.553z"/>
                                    </svg>
                                    <span className='text-sm'>موسیقی های من</span>
                                </MenuItem>
                                <MenuItem onClick={handleClose} sx={{borderRadius: '1rem'}} className='hover:text-red-600'>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         strokeWidth={1.5}
                                         stroke="currentColor" className="w-4 h-4 ml-2">
                                        <path strokeLinecap="round" strokeLinejoin="round"
                                              d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"/>
                                    </svg>
                                    <span className='text-sm'>خروج</span>
                                </MenuItem>
                            </Menu>
                        </React.Fragment>
                        :
                        <div
                            className='flex flex-row text-gray-700 font-bold hover:bg-gray-100 transition p-2 rounded-lg'>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                                 stroke="currentColor" className="w-6 h-6 ml-2">
                                <path strokeLinecap="round" strokeLinejoin="round"
                                      d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"/>
                            </svg>
                            <span className='font-bold'>ورود</span>
                        </div>
                }
        </header>
);
}
